import type { Store } from 'effector'
import type { LibraryTabNames } from './index.h'

import { combine, createEvent, createStore, sample } from 'effector'
import { model as i18n } from '~/core/i18n'
import { model as router } from '~/core/router'
import { LibraryTabs, QUERY_LIBRARY_TAB } from './index.h'
import { isQueryTabNotEqualNextTab } from './lib'

export const selectLibraryActiveTab = createEvent<LibraryTabs>()

export const $libraryActiveTab = createStore<LibraryTabs | null>(null).on(
  selectLibraryActiveTab,
  (_, id) => id
)

export const $libraryTabNames: Store<LibraryTabNames> = combine(
  i18n.$t,
  ({ t }) => ({
    favorites: t('favorites'),
    purchased: t('purchased'),
  })
)

sample({
  clock: selectLibraryActiveTab,
  source: router.$query,
  filter: (query, nextTab) => isQueryTabNotEqualNextTab(query, nextTab),
  fn: (_, nextTab) => ({ [QUERY_LIBRARY_TAB]: nextTab }),
  target: router.navigatePushQuery,
})
